<div class="section" [style.backgroundColor]="!isDarkMode ? '#000000' : '#FFFFFF'"
  [style.color]="!isDarkMode ? '#FFFFFF' : '#000000'"
  *ngFor="let movie of movies">
  <div class="container">
    <div class="w-100 d-flex justify-content-center p-5 flex-column align-items-center" *ngIf="!(movie?.expiration | checkExpiration); else movieExpired;">
      <h2>{{ movie.name }}</h2>
      <video height="auto" controls>
        <source [src]="movie.url" [type]="movie.type">
        <!-- <track *ngIf="movie.subtitle" label="English" kind="subtitles" srclang="en" [src]="movie.subtitle" default> -->
      </video>
      <div class="d-flex justify-content-between flex-row w-50">
        <button class="btn btn-success btn-lg mt-5" (click)="downloadMovie(movie)"> DOWNLOAD </button>
        <button class="btn btn-lg mt-5"[ngClass]="{ 'btn-light': !isDarkMode, 'btn-dark': isDarkMode }" (click)="changeTheme()">
          {{ !isDarkMode ? 'CHANGE TO LIGHT MODE' : 'CHANGE TO DARK MODE' }}
        </button>
      </div>
    </div>
    <ng-template #movieExpired>
      <div class="w-100 d-flex justify-content-center mt-5">
        <img class="w-75 my-auto mx-0" src="/assets/images/expired.gif">
      </div>
    </ng-template>
  </div>
</div>
